/**
 * Input Schema of CargaTemp
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'

/* TODO: review generated schema */
export class InputCargaTempSchema extends Schema {
  readonly name = 'InputCargaTemp'

  readonly fieldSet: FieldSet<CargaTemp> = {}
}
